<template>
    <v-container fluid class="main-container d-block pa-0">
        <DeviceHeaderMenu :room-data="roomData" no-settings @back="back"/>
        <div class="container-form">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent
            >
                <v-flex class="title-h1-text d-inline-flex justify-center" xs12>
                    {{waitingTitle}}
                </v-flex>
                <v-layout row ma-0 mb-2>
                    <v-flex class="d-inline-flex container-form__row">
                        <v-text-field
                            v-model="dataScenario.name"
                            placeholder="Название"
                            class="input-form-grey error-field"
                            :rules="rules"
                            :error="error"
                            :error-messages="errorMessage"
                            @input="deleteError"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex container-form__row">
                        <v-select
                            v-model="controller"
                            placeholder="Контроллер"
                            class="input-form-grey error-field"
                            :items="controllers"
                            item-text="name"
                            item-value="uid"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            :rules="rules"
                            :error="error"
                            :error-messages="errorMessage"
                            @change="deleteError"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                </v-layout>
                <v-layout row ma-0 mb-2>
                    <v-flex class="d-inline-flex container-form__row">
                        <v-select
                            v-model="dataScenario.scenario_type"
                            placeholder="Тип сценария"
                            class="input-form-grey error-field scenario-type"
                            :items="scenarioTypes"
                            item-text="name"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            :rules="rules"
                            :error="error"
                            :error-messages="errorMessage"
                            @change="deleteError"
                        >
                            <template #item="{item}">
                                <v-flex class="menu-item__scenario-type d-inline-flex align-center">
                                    <v-img
                                        max-height="20px"
                                        max-width="20px"
                                        :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)"
                                        class="d-inline-flex mr-3"
                                    />
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex class="d-inline-flex align-center">
                                    <v-img
                                        max-height="20px"
                                        max-width="20px"
                                        :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)"
                                        class="d-inline-flex mr-3"
                                    />
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="d-inline-flex container-form__row">
                        <v-combobox
                            v-model="dataScenario.location"
                            placeholder="Расположение"
                            class="input-form-grey"
                            :items="locations"
                            :rules="rules"
                            hide-details
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            @update:search-input="setLocation"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item}}</v-flex>
                            </template>
                        </v-combobox>
                    </v-flex>
                </v-layout>
                <v-layout row ma-0 mb-2>
                    <v-flex class="d-inline-flex container-form__row">
                        <v-select
                            v-model="dataScenario.mode_work_scenario"
                            placeholder="Выполнение сценария"
                            class="input-form-grey error-field scenario-mode"
                            :items="endScenarioMode"
                            item-text="name"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            :rules="rules"
                            :error="error"
                            :error-messages="errorMessage"
                            @change="deleteError"
                        >
                            <template #item="{item}">
                                <v-flex column class="menu-item__scenario-mode">
                                    <div class="d-inline-flex align-center">
                                        <v-img max-height="24px" max-width="24px" :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)" class="d-inline-flex"/>
                                        <span class="main-text ml-3">{{item.name}}</span>
                                    </div>
                                    <div class="small-text grey-text flex-wrap" style="margin-left: 30px" v-html="item.text"></div>
                                </v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="container-form__row" >
                        <v-layout row class="ma-0 align-center">
                            <div class="main-text mr-3">
                                Активировать по дням:
                            </div>
                            <v-flex class="d-inline-flex">
                                <v-layout row ma-0 class="devices-list__block__title">
                                    <v-flex class="d-inline-flex">
                                        <div
                                            v-for="(day, index) in weekdays"
                                            :key="index"
                                            class="weekday"
                                            :class="{'weekday__active': scenarioDays.includes(index)}"
                                            @click="setDay(index)"
                                        >
                                            {{ day }}
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row ma-0>
    <!--                <v-flex xs12 v-if="dataScenario.scenario_type == 1">-->
                    <v-layout row ma-0 w-100 v-if="dataScenario.scenario_type == 1">
                        <v-flex class="container-form__row">
                            <v-select
                                v-model="activeType"
                                placeholder="Выберете тип"
                                class="input-form-grey error-field scenario-mode"
                                :items="activeTypes"
                                item-text="name"
                                item-value="value"
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                            >
                                <template #item="{item}">
                                    <v-flex column class="menu-item__scenario-mode">
                                        <div class="d-inline-flex align-center">
                                            <v-img max-height="20px" max-width="20px" :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)" class="d-inline-flex"/>
                                            <span class="main-text ml-3">{{item.name}}</span>
                                        </div>
                                    </v-flex>
                                </template>
                                <template #selection="{item}">
                                    <v-flex class="d-inline-flex align-center">
                                        <v-img
                                            max-height="20px"
                                            max-width="20px"
                                            :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)"
                                            class="d-inline-flex mr-3"
                                        />
                                        {{item.name}}
                                    </v-flex>
                                </template>
                                <template #no-data>
                                    <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                </template>
                            </v-select>
                        </v-flex>
    <!--                <v-flex xs12 class="mb-2" v-if="dataScenario.scenario_type == 1 && activeType == 'time'">-->
                        <v-flex class="container-form__row" v-if="dataScenario.scenario_type == 1 && activeType == 'time'">
                            <time-field
                                v-model="timeActive"
                                title="Время активации сценария:"
                                placeholder="Время активации сценария"
                            />
                        </v-flex>
    <!--                <v-flex xs12 class="mb-2" v-if="dataScenario.scenario_type == 1 && activeType == 'day'">-->
                        <v-flex class="container-form__row" v-if="dataScenario.scenario_type == 1 && activeType == 'day'">
                            <v-select
                                v-model="dayType"
                                placeholder="Выберете время суток"
                                class="input-form-grey scenario-mode"
                                :items="dayTypes"
                                item-text="name"
                                item-value="value"
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                            >
                                <template #item="{item}">
                                    <v-flex column class="menu-item__scenario-mode">
                                        <div class="d-inline-flex align-center">
                                            <v-img max-height="20px" max-width="20px" :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)" class="d-inline-flex"/>
                                            <span class="main-text ml-3">{{item.name}}</span>
                                        </div>
                                    </v-flex>
                                </template>
                                <template #selection="{item}">
                                    <v-flex class="d-inline-flex align-center">
                                        <v-img
                                            max-height="20px"
                                            max-width="20px"
                                            :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)"
                                            class="d-inline-flex mr-3"
                                        />
                                        {{item.name}}
                                    </v-flex>
                                </template>
                                <template #no-data>
                                    <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row ma-0 w-100 v-if="dataScenario.scenario_type == 4">
                        <v-flex class="container-form__row">
    <!--                <v-flex xs12 class="mb-2" v-if="dataScenario.scenario_type == 4">-->
                            <time-field
                                v-model="launchPeriod"
                                title="Периодичность запуска:"
                                placeholder="Периодичность запуска"
                                max="12:00"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout row mx-0 mt-4 w-100>
                        <v-flex class="container-form__row mb-4">
                            <time-field
                                v-model="timeStart"
                                title="Время начала работы сценария:"
                                placeholder="Время начала работы сценария"
                            />
                        </v-flex>
                        <v-flex class="container-form__row mb-4">
                            <time-field
                                v-model="timeEnd"
                                title="Время окончания работы сценария:"
                                placeholder="Время окончания работы сценария"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout row ma-0 w-100>
                        <v-flex class="container-form__row">
                            <v-flex xs12 class="bold-text mb-3">Действия</v-flex>
                            <ActionsForm
                                :actionsData.sync="actions"
                                :devices="roomDevices"
                                :scenarios="scenarios"
                                :groups="groups"
                                :available="availableActions"
                                :edit="actionsEdit"
                                ref="actionsForm"
                            ></ActionsForm>
                        </v-flex>
                        <v-flex class="container-form__row">
                            <v-flex xs12 class="bold-text mb-3">Условия</v-flex>
                            <ConditionsForm
                                :conditionsData.sync="conditions"
                                :devices="roomDevices"
                                :scenarios="scenarios"
                                :available="availableConditions"
                                :edit="conditionsEdit"
                                ref="conditionsForm"
                            ></ConditionsForm>
                        </v-flex>
                    </v-layout>
                    <v-layout row ma-0 my-5 w-100>
                        <v-flex class="container-form__row"></v-flex>
                        <v-flex class="container-form__row d-flex justify-space-between">
                            <div class="d-inline-flex btn-block" style="width: auto; max-width: 50%;">
                                <v-switch
                                    v-model="!dataScenario.hidden"
                                    inset
                                    dense
                                    hide-details
                                    class="pa-0 ma-0"
                                    color="#FF8484"
                                ></v-switch>
                                <div class="main-text ml-2">Сценарий доступен гостю</div>
                            </div>
                            <div class="d-inline-flex" style="width: auto; min-width: 216px;">
                                <v-btn class="btn-grey main-text" @click="back">
                                    Отмена
                                </v-btn>
                                <v-btn :disabled="!valid" @click="validate" type="submit" class="btn-save main-text">
                                    Сохранить
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-form>
        </div>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных"></ModalWaiting>
        <ModalWaiting ref="modalError" title="Ошибка сохранения" :text="errorModalMessage" no-loading text-center></ModalWaiting>
    </v-container>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";
import DeviceHeaderMenu from "@/components/DeviceHeaderMenu";
import ActionsForm from "@/components/form/ActionsForm";
import ConditionsForm from "@/components/form/ConditionsForm";

export default {
    name: "AddScenario",
    components: {ModalWaiting, DeviceHeaderMenu, ActionsForm, ConditionsForm},
    data() {
        return {
            roomId: null,
            roomData: {},
            controllers: [],
            timeActive: "12:00",
            timeStart: "00:00",
            timeEnd: "23:59",
            launchPeriod: "00:01",
            weekdays: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
            scenarioDays: [0, 1, 2, 3, 4, 5, 6],
            controller: null,
            dataScenario: {},
            scenarioTypes: [
                {
                    name: "Запуск по таймеру",
                    value: 1,
                    icon: "clock",
                },
                {
                    name: "Запуск вручную",
                    value: 2,
                    icon: "pointer",
                },
                {
                    name: "Запуск по условию",
                    value: 3,
                    icon: "condition",
                },
                {
                    name: "Цикличный запуск",
                    value: 4,
                    icon: "cycle",
                },
            ],
            devices: [],
            roomDevices: [],
            conditions: [],
            actions: [],
            availableActions: {},
            availableConditions: {},
            scenarios: [],
            locations: [],
            groups: [],
            activeTypes: [
                {
                    name: "Время",
                    value: "time",
                    icon: "simple_clock",
                },
                {
                    name: "Время суток",
                    value: "day",
                    icon: "moon_sun",
                },
            ],
            activeType: null,
            dayTypes: [
                {
                    name: "Рассвет",
                    value: "dawn",
                    icon: "dawn",
                },
                {
                    name: "Восход",
                    value: "sunrise",
                    icon: "sunrise",
                },
                {
                    name: "Полдень",
                    value: "noon",
                    icon: "noon",
                },
                {
                    name: "Закат",
                    value: "sunset",
                    icon: "sunset",
                },
                {
                    name: "Сумерки",
                    value: "dusk",
                    icon: "dusk",
                },
            ],
            dayType: null,
            scenarioID: null,
            conditionsEdit: [],
            actionsEdit: [],
            save: false,
            rules: [value => !!value || 'Обязательное поле'],
            valid: true,
            error: null,
            errorMessage: null,
            errorModalMessage: null,
            endScenarioMode: [
                {
                    name: "Завершить в любом случае",
                    value: 1,
                    text: "Сценарий выполнится до конца, даже если<br>какие-то команды запустятся с ошибкой",
                    icon: "continue",
                },
                {
                    name: "Прервать в случае ошибки",
                    value: 2,
                    text: "Если на каком-то шаге появится ошибка,<br>последующие действия не выполнятся",
                    icon: "interrupt",
                },
            ]
        };
    },
    created() {
        this.roomId = this.$route.params.id;
        this.getConditions();
        this.getScenarios();
    },
    mounted() {
        if (this.roomId) {
            this.getRoom();
            this.getControllers();
        }
    },
    computed: {
        waitingTitle() {
            if (this.scenarioID) {
                return "Редактирование сценария";
            } else {
                return "Добавление сценария";
            }
        },
    },
    watch: {
        controller(val) {
            if (val) {
                this.getDevices();
            } else {
                this.roomDevices = [];
                this.devices = [];
            }
        },
    },
    methods: {
        getRoom() {
            this.roomData = {
                free: false,
            };
            this.$http.get('/hotels/hotel-admin/rooms/' + this.roomId + '/')
                .then((response) => {
                    this.roomData = response.data;
                    if (this.roomData && this.roomData.hotel) {
                        this.$store.commit("setTimezone", this.roomData.hotel.timezone);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$refs.modalWaiting.close();
                });
        },
        getControllers() {
            this.$refs.modalWaiting.open();
            this.$http.get('/controllers/hotel-admin/management-controller/' + this.roomId + '/')
                .then((response) => {
                    this.controllers = response.data.results;
                    if (this.$route.query.scenario) {
                        this.scenarioID = this.$route.query.scenario;
                        this.getScenarioData();
                    } else {
                        this.$refs.modalWaiting.close();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$refs.modalWaiting.close();
                });
        },
        getConditions() {
            this.$http.get('/scenarios/hotel-admin/scenarios/available-conditions-and-actions/')
                .then((response) => {
                    this.availableActions = response.data.actions;
                    this.availableConditions = response.data.conditions;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getScenarios() {
            this.scenarios = [];
            this.$http.get('/scenarios/hotel-admin/scenarios-list/' + this.roomId + '/')
                .then((response) => {
                    this.scenarios = response.data.scenarios;
                    this.locations = response.data.locations;
                    this.groups = response.data.groups;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addScenario() {
            if (this.save) {
                return;
            }
            this.$refs.modalWaiting.open();
            this.save = true;
            if (!this.dataScenario.hidden) {
                this.dataScenario.hidden = false;
            }
            this.dataScenario.controller = this.controller;
            if (this.dataScenario.scenario_type == 1) {
                if (this.timeActive && this.activeType == "time") {
                    this.dataScenario.time_start = this.timeActive;
                } else if (this.dayType && this.activeType == "day") {
                    this.dataScenario.time_start = this.dayType;
                }
            }
            this.dataScenario.weekdays = this.scenarioDays;
            // if (this.timeStart) {
                this.dataScenario.time_interval_for_launching_start = this.timeStart;
            // }
            // if (this.timeEnd) {
                this.dataScenario.time_interval_for_launching_end = this.timeEnd;
            // }
            if (this.launchPeriod && this.dataScenario.scenario_type == 4) {
                let [hours, minutes] = this.launchPeriod.split(":");
                let period = (parseInt(hours) * 60 + parseInt(minutes)) * 60;
                this.dataScenario.launch_period = period;
            }

            this.$refs.conditionsForm.update();
            this.$refs.actionsForm.update();
            let conditionsArr = [];
            this.conditions.forEach((el, index) => {
                let element = {
                    index: index,
                    type: el.type == 5 ? 3 : el.type
                };
                if (el.device) {
                    element.trigger = el.trigger;
                    element.device = el.device.uid;
                }
                if (el.scenario) {
                    element.scenario = el.scenario.uid;
                }
                if (el.oper) {
                    element.operator = el.oper.value;
                }
                if (el.device || el.scenario || el.type == 4) {
                    let val = null;
                    if (el.variable.value_type == "int") {
                        val = parseInt(el.number);
                    }
                    if (el.variable.value_type == "time") {
                        val = el.time;
                    }
                    if (el.variable.value_type == "select") {
                        val = el.state ? el.state.value : el.state;
                    }
                    element.condition = {
                        field: el.variable.key,
                        value: val,
                        comparison_operator: el.comparison_operator,
                    };
                }
                conditionsArr.push(element);
            });
            let actionsArr = [];
            this.actions.forEach((el, index) => {
                let element = {
                    index: index,
                };
                if (el.device) {
                    element.device = el.device.uid;
                }
                if (el.scenario) {
                    element.scenario = el.scenario.uid;
                }
                if (el.group) {
                    element.scenario_group = el.group.uid;
                }
                if (el.sleep) {
                    element.sleep = el.sleep;
                }
                if (el.device || el.scenario || el.group) {
                    element.state = {};
                    if (el.variable.value_type == "int") {
                        element.state[el.variable.key] = parseInt(el.number);
                    } else {
                        element.state[el.variable.key] = el.state.value || el.state;
                    }
                    // element.state = {
                    //     field: el.variable.key,
                    //     value: el.variable.value_type == "int" ? el.number : el.state,
                    // };
                }
                actionsArr.push(element);
            });
            this.dataScenario.conditions = conditionsArr;
            this.dataScenario.actions = actionsArr;

            let method = "post";
            let url = "/scenarios/hotel-admin/scenarios/";
            if (this.scenarioID) {
                method = "put";
                url = "/scenarios/hotel-admin/scenarios/" + this.scenarioID + "/";
            }
            this.$http[method](url, this.dataScenario)
                .then(() => {
                    this.$refs.modalWaiting.close();
                    this.back();
                })
                .catch((error) => {
                    console.log(error);
                    this.errorModalMessage = error.response ? error.response.data[0].message : null;
                    this.$refs.modalWaiting.close();
                    this.$refs.modalError.open();
                })
                .finally(() => {
                    this.save = false;
                });
        },
        setDay(i) {
            let index = this.scenarioDays.indexOf(i);
            if (index != -1) {
                this.scenarioDays.splice(index, 1);
            } else {
                this.scenarioDays.push(i);
            }
        },
        getDevices() {
            this.$http.get('/devices/hotel-admin/device-list/' + this.roomId + '/?controller=' + this.controller)
                .then((response) => {
                    this.roomDevices = response.data.devices;
                    if (this.scenario) {
                        this.devices.forEach((el) => {
                            el.device = this.roomDevices.find((device) => {
                                return el.device == device.uid
                            });
                            if (typeof el.value != "boolean") {
                                el.temperature = el.value;
                                el.percent = el.value;
                                el.value = true;
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setLocation(val) {
            this.dataScenario.location = val;
        },
        getScenarioData() {
            this.dataScenario = {};
            this.$http.get('/scenarios/hotel-admin/scenarios/' + this.scenarioID + '/')
                .then((response) => {
                    this.controller = response.data.controller;
                    this.dataScenario.name = response.data.name;
                    this.dataScenario.location = response.data.location;
                    this.dataScenario.scenario_type = response.data.scenario_type;
                    this.dataScenario.mode_work_scenario = response.data.mode_work_scenario;
                    if (response.data.weekdays) {
                        this.scenarioDays = response.data.weekdays;
                    }
                    if (this.dataScenario.scenario_type == 1) {
                        let day = this.dayTypes.find((el) => {
                            return el.value == response.data.time_start;
                        });
                        this.activeType = day ? "day" : "time";
                        if (day) {
                            this.dayType = response.data.time_start;
                        } else {
                            this.timeActive = response.data.time_start;
                        }
                    }
                    if (this.dataScenario.scenario_type == 4 && response.data.launch_period) {
                        let period = response.data.launch_period / 60;
                        let periodMinutes = period % 60;
                        let periodHours = parseInt(period / 60);
                        this.launchPeriod = `${String(periodHours).padStart(2, "0")}:${String(periodMinutes).padStart(2, "0")}`;
                    }
                    this.timeStart = response.data.time_interval_for_launching_start;
                    this.timeEnd = response.data.time_interval_for_launching_end;
                    this.dataScenario.hidden = !response.data.hidden;
                    this.actionsEdit = response.data.actions;
                    this.conditionsEdit = response.data.conditions;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.$refs.modalWaiting.close();
                });
        },
        validate() {
            this.valid = this.$refs.form.validate();
            this.errorModalMessage = null;
            if (this.valid) {
                if (this.dataScenario.scenario_type == 3) {
                    if (this.conditions.length == 0) {
                        this.errorModalMessage = "Обязательно добавление условия";
                        this.$refs.modalError.open();
                    }
                }
                if (this.actions.length == 0) {
                    this.errorModalMessage = "Обязательно добавление действия";
                    this.$refs.modalError.open();
                }
                if (!this.errorModalMessage) {
                    this.addScenario();
                }
            } else {
                this.error = true;
                this.errorMessage = "Обязательное поле";
            }
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
        back() {
            this.$router.push({
                name: "roompage",
                params: { id: this.roomId, tab: "scenarios", edit: true },
                query: { location: this.$route.query.location }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.main-container {
    height: 100%;
    text-align: center;

    .container-form {
        width: 100%;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        text-align: left;
        padding: 0 40px;
    }
}

.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 165px;
}

.weekday {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    border-radius: 40px;
    width: 41px;
    height: 35px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    color: #130F26;

    &__active {
        background: linear-gradient(180deg, #FFF4BC 0%, rgba(255, 132, 132, 0.8) 100%);
        color: #130F26;
    }
}

.v-input.v-text-field {
    background: rgba(255, 255, 255, 0.5) !important;
}

.btn-block .v-input.v-input--switch:not(.v-input--is-label-active)::v-deep .v-input--switch__track {
    background: rgba(255, 255, 255, 0.5) !important;
}

.v-input.input-form-grey {
    &::v-deep .v-input__control {
        .v-input__slot {
            margin-bottom: 0;
            top: 14px;

            .v-text-field__slot {
                height: 40px;
            }
        }
    }

    &.error-field {
        &::v-deep .v-input__control {
            .v-text-field__details {
                top: 12px;
                position: relative;
            }
        }
    }

    &.v-select::v-deep .v-input__control {
        .v-text-field__details {
            top: 16px;
        }
    }
}
</style>